var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-root"},[_c('div',{staticClass:"layout-bar text-center"},[_c('router-link',{staticClass:"ml-3 h-100 d-inline-flex align-items-center",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("../../assets/Kingsland_Seal_White.png"),"alt":"Kingsland Logo"}})])],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }